import style from './../Report.module.scss';
import TreatmentsByTimeGraph from './TreatmentsByTimeGraph/TreatmentsByTimeGraph';
import TreatmentsByStaff from './TreatmentsByStaff/TreatmentsByStaff';
import TreatmentsByArea from './TreatmentsByArea/TreatmentsByArea';
import TreatmentsBySkin from './TreatmentsBySkin/TreatmentsBySkin';
import ReportTypeStructure from '../ReportTypeStructure';
import moment from 'moment';

const TreatmentsReport = ({ report, isStandalone }) => {
    const { data } = report;
    const { clinic, treatments } = data;

    const getHeader = () => {
        return (
            <div className='d-flex'>
                { clinic && clinic.logo && <img src={ clinic.logo } alt='logo' className={ style.clinicLogo } /> }
                <div>
                    <h1>{clinic && clinic.name ? clinic.name : 'Unknown clinic'}: Treatments Report</h1>
                    <label className={style.reportType}>{moment(report.filters.date_range.startDate).format('ll')} - {moment(report.filters.date_range.endDate).format('ll')}</label>
                </div>
            </div>
        )
    }

    const getContent = () => {
        return (
            <>
                <section>
                    <h5>Treatments Overview</h5>
                    <div className={style.cardRow}>
                        <div className={[style.card, style.col4].join(' ')}>
                            <h3>{treatments.stats.total}</h3>
                            <label>Total Treatments</label>
                        </div>
                        <div className={[style.card, style.col4].join(' ')}>
                            <h3>{treatments.stats.weekly_average}</h3>
                            <label>Avg. Weekly Treatments</label>
                        </div>
                        <div className={[style.card, style.col4].join(' ')}>
                            <h3>{treatments.stats.most_popular_area}</h3>
                            <label>Most Popular Area</label>
                        </div>
                    </div>

                    <div className={ style.cardRow }>
                        <div className={ [ style.card, style.col6 ].join(' ') } style={ { minHeight: 300 } }>
                            <TreatmentsByTimeGraph data={ treatments.by_time.data } tick={ treatments.by_time.tick } />
                        </div>
                        <div className={ [ style.card, style.col6 ].join(' ') }>
                            <TreatmentsByArea data={ treatments.by_area } />
                        </div>
                    </div>

                    <div className={ style.cardRow }>
                        <div className={ [ style.card, style.col6 ].join(' ') }>
                            <TreatmentsByStaff data={ treatments.by_staff } />
                        </div>
                        <div className={ [ style.card, style.col6 ].join(' ') }>
                            <TreatmentsBySkin data={ treatments.by_skin_type } />
                        </div>
                    </div>
                </section>
            </>
        )
    }
    return (
        <ReportTypeStructure isStandalone={isStandalone} report={report} header={ getHeader() } content={ getContent() } />
    )
}

export default TreatmentsReport;